import { ReactNode } from 'react'
import { classNames } from '@/util/tailwindHelpers'
import ArcadeShelfWrapperGradient from './ArcadeShelfWrapperGradient'
import styles from './styles.module.scss'

type Props = {
  children: ReactNode
  className?: string
  bgClassName?: string
}
const ArcadeShelfWrapper = ({ children, className, bgClassName }: Props) => {
  return (
    <div className={classNames('relative', className)}>
      <div>
        <ArcadeShelfWrapperGradient />
        <div className={classNames(styles.dotBg, bgClassName)} />
      </div>
      <div className="w-full h-18 absolute bottom-0">
        <div
          className="h-14"
          style={{
            backgroundImage: 'linear-gradient(180deg, #090909 0%, #1A1A1A 100%)'
          }}
        />
        <div
          className="h-4"
          style={{
            backgroundImage:
              'linear-gradient(90deg, #212121 0%, #242424 52%, #212121 100%)'
          }}
        />
      </div>
      {children}
    </div>
  )
}

export default ArcadeShelfWrapper
